import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberCoupon/page', data, {
    trim: true
  })
}
